/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { MdOutlineStar, MdOutlineStarOutline } from 'react-icons/md';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import { useIntl } from 'react-intl';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppLink from '../../../shared/components/app-link/AppLink';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import {
  formatCurrency,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';

function HotelFilters({
  minPrice,
  maxPrice,
  selectedFilters,
  onApplyFilter,
  amenitiesList,
  onClearFilters,
  currencyOption,
  conversionRate,
  hotelNames,
  hotelLocations,
  starCount,
  facilities,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [selectedMinPrice, setSelectedMinPrice] = useState(minPrice);
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(maxPrice);
  const [hotelName, setHotelName] = useState('');
  const [hotelAddress, setHotelAddress] = useState('');
  const [selectedRating, setSelectedRating] = useState([]);
  const [showRating, setShowRating] = useState(true);
  const [showPriceSlider, setShowPriceSlider] = useState(true);
  const [showFacilities, setShowFacilities] = useState(true);
  const [selectedFacilities, setSelectedFacilities] = useState(
    selectedFilters.selectedFacilities,
  );
  useEffect(() => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
  }, [minPrice, maxPrice]);

  useEffect(() => {
    setSelectedRating(selectedFilters.selectedRating);
  }, [selectedFilters.selectedRating]);

  const handleChipSelection = (name, value) => {
    let list = [];
    if (name === 'rating') {
      list = [...selectedRating];
    } else if (name === 'facilities') {
      list = [...selectedFacilities];
    }
    const index = list.indexOf(value);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(value);
    }
    if (name === 'rating') {
      setSelectedRating(list);
    } else if (name === 'facilities') {
      setSelectedFacilities(list);
    }
    if (name === 'rating') {
      if (!isMobileWidth()) {
        onApplyFilter({
          selectedMinPrice,
          selectedMaxPrice,
          hotelName,
          hotelAddress,
          selectedRating: list,
          selectedFacilities,
        });
      }
    }
    if (name === 'facilities') {
      if (!isMobileWidth()) {
        onApplyFilter({
          selectedMinPrice,
          selectedMaxPrice,
          hotelName,
          hotelAddress,
          selectedRating,
          selectedFacilities: list,
        });
      }
    }
  };
  const handleSliderChange = (newValues) => {
    setSelectedMinPrice(newValues[0]);
    setSelectedMaxPrice(newValues[1]);
    if (!isMobileWidth()) {
      onApplyFilter({
        selectedMinPrice: newValues[0],
        selectedMaxPrice: newValues[1],
        hotelName,
        hotelAddress,
        selectedRating,
        selectedFacilities,
      });
    }
  };

  const handleClearFilters = () => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
    setSelectedRating([]);
    setSelectedFacilities([]);
    setHotelName('');
    setHotelAddress('');
    onClearFilters();
  };

  const handleSelect = (name, value) => {
    if (name === 'hotelName') {
      setHotelName(value);
      if (!isMobileWidth()) {
        onApplyFilter({
          selectedMinPrice,
          selectedMaxPrice,
          hotelName: value,
          hotelAddress,
          selectedRating,
          selectedFacilities,
        });
      }
    }
    if (name === 'hotelAddress') {
      setHotelAddress(value);
      if (!isMobileWidth()) {
        onApplyFilter({
          selectedMinPrice,
          selectedMaxPrice,
          hotelName,
          hotelAddress: value,
          selectedRating,
          selectedFacilities,
        });
      }
    }
  };

  const handleApplyMobileFilter = () => {
    onApplyFilter({
      selectedMinPrice,
      selectedMaxPrice,
      hotelName,
      hotelAddress,
      selectedRating,
      selectedFacilities,
    });
  };

  return (
    <section
      className="one-way-flight-filters"
      style={isMobileWidth() ? { paddingBottom: '100px' } : {}}
    >
      <div className="one-way-flight-filters_section fs-12">
        <div className="d-flex mb-2 fw-600 justify-content-end">
          <AppLink
            variant="secondary"
            linkText="Clear"
            onClick={() => handleSelect('hotelName', '')}
          />
        </div>
        <AppSelect
          label={formattedMessage('hotel_name')}
          name="hotelName"
          placeholder="Hotel Name"
          options={hotelNames}
          selectedValue={hotelName}
          onSelect={(data) => handleSelect('hotelName', data.value)}
          isClearable={false}
          menuShouldScrollIntoView={false} // ✅ prevents scroll on open
          formatOptionLabel={(option) => (
            <div>
              <div style={{ fontWeight: 600 }}>{option.label}</div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {option.address}
              </div>
            </div>
          )}
        />
      </div>
      <div className="one-way-flight-filters_section fs-12">
        <div className="d-flex mb-2 fw-600 justify-content-end">
          <AppLink
            variant="secondary"
            linkText="clear"
            onClick={() => handleSelect('hotelAddress', '')}
          />
        </div>
        <AppSelect
          label={formattedMessage('location_name')}
          name="hotelAddress"
          placeholder="Hotel Location"
          options={hotelLocations}
          selectedValue={hotelAddress}
          onSelect={(data) => handleSelect('hotelAddress', data.value)}
          isClearable={false}
          menuShouldScrollIntoView={false}
        />
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">
          <div className="d-flex justify-content-between">
            <span>{formattedMessage('price')}</span>
            <AppLink
              linkText={formattedMessage('hide')}
              onClick={() => setShowPriceSlider((prev) => !prev)}
              variant="secondary"
            />
          </div>
        </div>
        {showPriceSlider && (
          <div className="one-way-flight-filters_section_content">
            <div>
              <span className="fs-12">
                {formatCurrency(selectedMinPrice)}-
                {formatCurrency(selectedMaxPrice)}
              </span>
            </div>
            <div className="my-2">
              <ReactSlider
                min={minPrice}
                max={maxPrice}
                value={[selectedMinPrice, selectedMaxPrice]}
                onChange={handleSliderChange}
              />
            </div>
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">
          <div className="d-flex justify-content-between">
            <span>{formattedMessage('star_rating')}</span>
            <AppLink
              linkText={formattedMessage('hide')}
              onClick={() => setShowRating((prev) => !prev)}
              variant="secondary"
            />
          </div>
        </div>
        {showRating && (
          <div className="one-way-flight-filters_section_content d-flex justify-content-between">
            <div
              className={`${
                selectedRating.indexOf('1') > -1
                  ? 'selected-star-chip'
                  : 'star-chip'
              }`}
              onClick={() => handleChipSelection('rating', '1')}
            >
              <span>
                {selectedRating.indexOf('1') > -1 ? (
                  <MdOutlineStar />
                ) : (
                  <MdOutlineStarOutline />
                )}
              </span>
              <span className="fs-14">1</span>
              {starCount && <span className="fs-12">({starCount[1]})</span>}
            </div>
            <div
              className={`${
                selectedRating.indexOf('2') > -1
                  ? 'selected-star-chip'
                  : 'star-chip'
              }`}
              onClick={() => handleChipSelection('rating', '2')}
            >
              <span>
                {selectedRating.indexOf('2') > -1 ? (
                  <MdOutlineStar />
                ) : (
                  <MdOutlineStarOutline />
                )}
              </span>
              <span className="fs-14">2</span>
              {starCount && <span className="fs-12">({starCount[2]})</span>}
            </div>
            <div
              className={`${
                selectedRating.indexOf('3') > -1
                  ? 'selected-star-chip'
                  : 'star-chip'
              }`}
              onClick={() => handleChipSelection('rating', '3')}
            >
              <span>
                {selectedRating.indexOf('3') > -1 ? (
                  <MdOutlineStar />
                ) : (
                  <MdOutlineStarOutline />
                )}
              </span>
              <span className="fs-14">3</span>
              {starCount && <span className="fs-12">({starCount[3]})</span>}
            </div>
            <div
              className={`${
                selectedRating.indexOf('4') > -1
                  ? 'selected-star-chip'
                  : 'star-chip'
              }`}
              onClick={() => handleChipSelection('rating', '4')}
            >
              <span>
                {selectedRating.indexOf('4') > -1 ? (
                  <MdOutlineStar />
                ) : (
                  <MdOutlineStarOutline />
                )}
              </span>
              <span className="fs-14">4</span>
              {starCount && <span className="fs-12">({starCount[4]})</span>}
            </div>
            <div
              className={`${
                selectedRating.indexOf('5') > -1
                  ? 'selected-star-chip'
                  : 'star-chip'
              }`}
              onClick={() => handleChipSelection('rating', '5')}
            >
              <span>
                {selectedRating.indexOf('5') > -1 ? (
                  <MdOutlineStar />
                ) : (
                  <MdOutlineStarOutline />
                )}
              </span>
              <span className="fs-14">5</span>
              {starCount && <span className="fs-12">({starCount[5]})</span>}
            </div>
          </div>
        )}
      </div>
      {facilities.length > 0 && (
        <div className="one-way-flight-filters_section">
          <div className="one-way-flight-filters_section_header">
            <div className="d-flex justify-content-between">
              <span>{formattedMessage('facilities')}</span>
              <AppLink
                linkText={formattedMessage('hide')}
                onClick={() => setShowFacilities((prev) => !prev)}
                variant="secondary"
              />
            </div>
          </div>
          {showFacilities && (
            <div className="one-way-flight-filters_section_content d-flex flex-column">
              {facilities.map((facility) => (
                <AppCheckBox
                  key={facility}
                  name="facilities"
                  labelText={facility}
                  labelClassName="fw-300 m-1"
                  checked={selectedFacilities.indexOf(facility) > -1}
                  onChange={() => handleChipSelection('facilities', facility)}
                />
              ))}
            </div>
          )}
        </div>
      )}

      {isMobileWidth() ? (
        <div className="d-flex gap-2 position-fixed bottom-0 z-3 white-background-color p-1 w-100">
          <AppButton
            btnText="Apply"
            variant="primary"
            className="flex-1"
            onClick={handleApplyMobileFilter}
          />
          <AppButton
            btnText="clear"
            variant="outlined"
            className="flex-1"
            onClick={handleClearFilters}
          />
        </div>
      ) : (
        <div
          className="d-flex justify-content-center py-2 pb-5"
          style={{ paddingBottom: '150px' }}
        >
          <AppButton
            btnText={formattedMessage('clear_btn')}
            variant="outlined"
            onClick={handleClearFilters}
          />
        </div>
      )}
    </section>
  );
}

HotelFilters.propTypes = {
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  amenitiesList: PropTypes.array.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.any.isRequired,
  hotelLocations: PropTypes.array.isRequired,
  hotelNames: PropTypes.array.isRequired,
  starCount: PropTypes.any.isRequired,
  facilities: PropTypes.array.isRequired,
};

export default HotelFilters;
